<template>
  <div id="event-archive">
    <div class="row mt-md-5 text-center article" v-html="body"></div>
    <div>
      <router-link v-b-toggle.collapse-1 to="/taiken.html"><img src="/static/images/common/back_to_taiken.png" class="img-fluid"></router-link>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'event_archive',
    list_data_file: '/static/data/events.csv', 
    data() {
      return {
        body: "",
        code: ""
      };
    },
    updated: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    },
    mounted() {
      this.code = this.$route.params['code']
      this.load();
    },
    methods: {
      load: function() {
        var file = `/static/data/event_archive/${this.code}.html`
        axios.get(file)
          .then( response => {
            if (response.status == 200) {
              this.body = response.data;
            } else {
              alert(t("fail_to_get_data"))
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EventArchive.vue